import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * Simple replacement for the `react-show-more-text` library.
 * It displays a truncated version of the content with a toggle link
 * to expand / collapse the full text.
 */
const ShowMoreText = ({
  children,
  lines = 3,
  more = 'Show more',
  less = 'Show less',
  anchorClass = '',
  expanded = false,
}) => {
  const [showAll, setShowAll] = useState(expanded);

  const toggle = () => setShowAll(!showAll);

  // Very simple truncation logic: cut after a reasonable number of characters.
  // The original library works with line counts; for our use‑case a character
  // limit provides a comparable experience without heavy layout calculations.
  const truncate = (content) => {
    if (typeof content !== 'string') return content;
    const limit = 200; // approx three lines for typical blog text
    if (content.length <= limit) return content;
    return `${content.slice(0, limit)}...`;
  };

  const displayedContent = showAll ? children : truncate(children);

  return (
    <div>
      {typeof displayedContent === 'string' ? (
        <span dangerouslySetInnerHTML={{ __html: displayedContent }} />
      ) : (
        displayedContent
      )}
      <a
        className={anchorClass}
        onClick={toggle}
        style={{ cursor: 'pointer', marginLeft: '8px' }}
      >
        {showAll ? less : more}
      </a>
    </div>
  );
};

ShowMoreText.propTypes = {
  children: PropTypes.node.isRequired,
  lines: PropTypes.number,
  more: PropTypes.string,
  less: PropTypes.string,
  anchorClass: PropTypes.string,
  expanded: PropTypes.bool,
};

export default ShowMoreText;
